import React, { Component } from 'react'

export default class Sidebar extends Component {
  render() {
    return (
      <div>
        <div>
          <nav href="#navbar" className="js-colorlib-nav-toggle colorlib-nav-toggle" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar"><i /></nav>
          <aside id="colorlib-aside" className="border js-fullheight">
            <div className="text-center">
              <div className="author-img" style={{ backgroundImage: 'url(https://avatars0.githubusercontent.com/u/25622540?s=460&v=4)' }} />
              <h1 id="colorlib-logo"><a href="index.html">Lihao Zhu</a></h1>
              <span className="email"><i className="icon-mail"></i> lihaozhu@seas.upenn.edu</span>
              <br />
            </div>
            <nav id="colorlib-main-menu" role="navigation" className="navbar">
              <div id="navbar" className="collapse">
                <ul>
                  <li><a href="#about" data-nav-section="about">About Me</a></li>
                  <li><a href="#blog" data-nav-section="blog">Blog Site</a></li>
                  <li><a href="#projects" data-nav-section="projects">Projects</a></li>
                </ul>
              </div>
            </nav>
            <nav id="colorlib-main-menu">
              <ul>
                <li><a href="https://www.linkedin.com/in/lihaozhu-2022/" target="_blank" rel="noopener noreferrer"><i className="icon-linkedin2" /></a></li>
                <li><a href="https://github.com/liz2020" target="_blank" rel="noopener noreferrer"><i className="icon-github"></i></a></li>
                <li><a href="https://liz2020.github.io/blogs/post/index.xml" target="_blank" rel="noopener noreferrer"><i className="icon-rss"/></a></li>
              </ul>
            </nav>
          </aside>
        </div>
      </div>
    )
  }
}
